import React, { useContext, useState } from 'react';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { UnsubscriptionModal } from '../EmailPreferences/UnsubscriptionModal';
import {
  unsubscribeFromAllEmail,
  unsubscribeFromAllEmailSuccess
} from '../../analytics/email';
import { addAnalyticEvent } from '../../analytics/common';
import { OptOutReasonFeedback } from '../OptOutReasonFeedback';
import { getSubscriptions, updateEmailPreferences } from '../../common/sharedFunctions';
import constants, { YES } from '../../constants/constants';
import { RETARGETING_TYPE } from '../tableData';
import { BannerContext, BannerProvider } from '../../contexts/BannerContext';
import ErrorBoundary from '../../contexts/ErrorBoundary';
import { ALL_EMAIL_UNSUBSCRIBE_SUCCESS } from '../../constants/bannerConstants';

function Preferences() {

  const {
    hideBanners,
    openSuccessAlert,
    openErrorAlert,
  } = useContext(BannerContext);

  const [unsubscribeToggle, setUnsubscribeToggle] = useState(false);
  const [selectedOptOuts, setSelectedOptOuts] = useState([]);
  const [emailAddress, setEmailAddress] = useState(null);

  const openUnsubscribeModal = () => {
    addAnalyticEvent(unsubscribeFromAllEmail);
    setUnsubscribeToggle(true);
    setSelectedOptOuts([]);
  };

  const handleUnsubCancel = () => {
    setUnsubscribeToggle(false);
  };

  const handleUnsubSuccess = (actualEmail, response, retrieveResponse) => {
    addAnalyticEvent(unsubscribeFromAllEmailSuccess);
    setEmailAddress(actualEmail);
    setUnsubscribeToggle(false);
    const subscriptions = getSubscriptions(retrieveResponse)
      .filter((sub) => sub.status === YES)
      .map((sub) => sub.type);
    setSelectedOptOuts(subscriptions.concat([RETARGETING_TYPE]));
    openSuccessAlert(ALL_EMAIL_UNSUBSCRIBE_SUCCESS, actualEmail);
  };

  const ignoreError = () => {};
  const handleOptOutReasonSuccess = () => {
    setSelectedOptOuts([]);
    hideBanners();
    openSuccessAlert(constants.UNSUB_REASON_SUCCESS);
  };

  const callApi = (subscriptions) => {

    updateEmailPreferences({
      emailAddress,
      subscriptions,
      table: null,
      callback: handleOptOutReasonSuccess,
      err: (err) => {
        if (err) {
          openErrorAlert(constants.OPTOUT_FEEDBACK_ERROR);
        }
      }
    });
  };

  return (
    <div className="component">
      <OptOutReasonFeedback
        setSelectedOptOuts={setSelectedOptOuts}
        selectedOptOuts={selectedOptOuts}
        callApi={callApi}
      />
      <Row>
        <Col>
          <h2>
            <u style={{ textDecorationColor: '#F96302' }}>Marketing Emails</u>
          </h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            To opt out of promotional emails from The Home Depot,
            click Opt Out of All Marketing Emails.
          </p>
        </Col>
      </Row>
      <Row>
        <Col nopadding xs={6} sm={8} md={8} lg={8} />
        <Col xs={6} sm={4} md={4} lg={4}>
          <Button outline onClick={openUnsubscribeModal}>Opt Out of All Marketing Emails</Button>
        </Col>
      </Row>

      {unsubscribeToggle && (
        <UnsubscriptionModal
          handleClose={handleUnsubCancel}
          handleSuccess={handleUnsubSuccess}
          handleError={ignoreError}
        />
      )}
    </div>
  );
}

export function EmailUnsubscribePreferences() {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences />
      </BannerProvider>
    </ErrorBoundary>
  );
}
